import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

import { createExpiringStorage } from '@/utils/storage'

import type { Location } from '@/graphql/generated-types'

export const locationAtom = atomWithStorage<Location | undefined>(
  'location',
  undefined,
  createExpiringStorage<Location | undefined>(10 * 60 * 1000)
)

export const currentLocationTabAtom = atom<
  'slideshows' | 'slides' | 'media library' | 'devices'
>('slideshows')
